"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Checkbox = _interopRequireDefault(require("./Checkbox"));

exports.default = _Checkbox.default;